import { render } from "./channelSluggishGoodsAnalyze.vue?vue&type=template&id=3845158e&scoped=true"
import script from "./channelSluggishGoodsAnalyze.vue?vue&type=script&lang=js"
export * from "./channelSluggishGoodsAnalyze.vue?vue&type=script&lang=js"

import "./channelSluggishGoodsAnalyze.vue?vue&type=style&index=0&id=3845158e&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3845158e"]])

export default __exports__